module.exports = "<div id=\"no-venues\" class=\"section-scrollable\">\n  <uh-oh-message class=\"uh-oh-message\" ng-show=\"true\" message=\"You do not have any venues yet.\" reason=\"{{ 'I don\\'t have any venues setup for my account.yet.' }}\" action-1=\"backToOrgSelect\">\n    <a class=\"btn btn-primary\" href=\"#\" ng-click=\"action1($event)\">\n      Go back to Select Company\n    </a>\n  </uh-oh-message>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/noVenues/noVenues.html
// module id = 1166
// module chunks = 0